module.exports = __webpack_public_path__ + "img/img5.e3861db1.png";